import React, { useState } from 'react';
import videoService from '../services/videoService';

const ThumbnailTest = () => {
  const [url, setUrl] = useState('https://www.youtube.com/watch?v=dQw4w9WgXcQ');
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const testThumbnail = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Testing URL:', url);
      const response = await videoService.generateThumbnail(url);
      console.log('Response:', response);
      setResult(response);
    } catch (err) {
      console.error('Error:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>🧪 Thumbnail Generation Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
          YouTube URL:
        </label>
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '14px',
            border: '2px solid #e0e0e0',
            borderRadius: '8px'
          }}
          placeholder="Enter YouTube URL"
        />
      </div>

      <button
        onClick={testThumbnail}
        disabled={loading}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          fontWeight: 'bold',
          backgroundColor: loading ? '#999' : '#667eea',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: loading ? 'not-allowed' : 'pointer',
          marginBottom: '20px'
        }}
      >
        {loading ? '🔄 Testing...' : '🧪 Test Thumbnail Generation'}
      </button>

      {error && (
        <div style={{
          padding: '20px',
          backgroundColor: '#fee',
          border: '2px solid #f00',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <h3 style={{ color: '#c00', marginTop: 0 }}>❌ Error</h3>
          <pre style={{ 
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-word',
            fontSize: '13px',
            backgroundColor: '#fff',
            padding: '10px',
            borderRadius: '4px'
          }}>
            {JSON.stringify(error, null, 2)}
          </pre>
        </div>
      )}

      {result && (
        <div style={{
          padding: '20px',
          backgroundColor: '#efe',
          border: '2px solid #0a0',
          borderRadius: '8px'
        }}>
          <h3 style={{ color: '#060', marginTop: 0 }}>✅ Success</h3>
          
          <div style={{ marginBottom: '15px' }}>
            <strong>Video ID:</strong> {result.thumbnails?.videoId}
          </div>

          <div style={{ marginBottom: '15px' }}>
            <strong>Available Thumbnails:</strong>
          </div>

          {result.thumbnails && Object.entries(result.thumbnails).map(([quality, url]) => {
            if (quality === 'videoId') return null;
            
            return (
              <div key={quality} style={{ marginBottom: '20px' }}>
                <div style={{ 
                  fontWeight: 'bold', 
                  marginBottom: '5px',
                  textTransform: 'uppercase',
                  color: '#667eea'
                }}>
                  {quality}
                </div>
                <img 
                  src={url} 
                  alt={`${quality} thumbnail`}
                  style={{ 
                    maxWidth: '100%', 
                    border: '2px solid #ddd',
                    borderRadius: '8px',
                    marginBottom: '5px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div style={{ display: 'none', color: '#c00', fontSize: '12px' }}>
                  ⚠️ Thumbnail not available at this quality
                </div>
                <div style={{ 
                  fontSize: '11px', 
                  color: '#666',
                  wordBreak: 'break-all',
                  backgroundColor: '#f5f5f5',
                  padding: '5px',
                  borderRadius: '4px'
                }}>
                  {url}
                </div>
              </div>
            );
          })}

          <details style={{ marginTop: '20px' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              📋 Raw Response
            </summary>
            <pre style={{ 
              whiteSpace: 'pre-wrap', 
              wordBreak: 'break-word',
              fontSize: '12px',
              backgroundColor: '#fff',
              padding: '10px',
              borderRadius: '4px',
              marginTop: '10px'
            }}>
              {JSON.stringify(result, null, 2)}
            </pre>
          </details>
        </div>
      )}

      <div style={{
        marginTop: '30px',
        padding: '20px',
        backgroundColor: '#f0f8ff',
        border: '2px solid #4682b4',
        borderRadius: '8px'
      }}>
        <h3 style={{ marginTop: 0 }}>💡 Test URLs</h3>
        <p>Try these known working URLs:</p>
        <ul style={{ fontSize: '13px' }}>
          <li>
            <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
              https://www.youtube.com/watch?v=dQw4w9WgXcQ
            </code>
          </li>
          <li>
            <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
              https://youtu.be/dQw4w9WgXcQ
            </code>
          </li>
          <li>
            <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>
              https://www.youtube.com/shorts/dQw4w9WgXcQ
            </code>
          </li>
        </ul>
      </div>

      <div style={{
        marginTop: '20px',
        padding: '15px',
        backgroundColor: '#fff3cd',
        border: '2px solid #ffc107',
        borderRadius: '8px',
        fontSize: '13px'
      }}>
        <strong>📝 Instructions:</strong>
        <ol style={{ marginBottom: 0 }}>
          <li>Open browser console (F12) to see detailed logs</li>
          <li>Enter a YouTube URL above</li>
          <li>Click "Test Thumbnail Generation"</li>
          <li>Check the result or error message</li>
        </ol>
      </div>
    </div>
  );
};

export default ThumbnailTest;
